/*-----------------------------------------------------*/
/*----------------Bind Product Drawer Start------------*/
/*-----------------------------------------------------*/ 

let shopping = String.fromCodePoint(0x1F973);
let chekking = String.fromCodePoint(0x2705);
let remove = String.fromCodePoint(0x1FAE5);
let update = String.fromCodePoint(0x1FAE1);





//Get Cart
async function getCart() {
    const result = await fetch(`${window.Shopify.routes.root}cart.json`);

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
    
}


//product details
async function getProduct(handle) {
  const result = await fetch(`/products/${handle}.json`, {
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      }
  });

  return result.json();
}








//Add to Cart new approach
async function addItem(data) {
  const result2 = await fetch(`${window.Shopify.routes.root}cart/add.json`, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify(data)
  })
  if (result2.status === 200) {
   console.log('%c'+chekking+' Item added '+ shopping +' successfully', 'font-size: 20px;');


    let list_on_page = $('#drawer_items');
    let subs_cont = $('.subs_wrapper');
    
      $.ajax({

          url: `${window.Shopify.routes.root}`,
          type : 'GET',
          dataType : 'html'
          
      }).done(function(drawer_items){
          
          let new_items = $(drawer_items).find('#drawer_items').find('.__item');
          let new_items_offer = $(drawer_items).find('#drawer_items').find('.offer_master');
          let new_total_price = $(drawer_items).find('#total_price').html();
          let new_basket_amount = $(drawer_items).find('#basket_item_counter').html();
          let new_instalment = $(drawer_items).find('#instalment_con').find('#bu_con').html();
          let new_modals = $(drawer_items).parent().parent().parent().parent().parent().parent().parent().find('.subs_wrapper').html();
      
   


          $('#drawer_items').find('.__item').remove(); 
          $('#drawer_items').find('.__item').remove(); 
          //$('#instalment_con').find('.instalment_drawer_text').remove(); 
          $('#instalment_con').find('#bu_con').remove(); 
          $('#drawer_items').find('.offer_master').remove();
          $('#drawer_items').parent().parent().parent().parent().parent().parent().parent().find('.subs_wrapper').find('.bambino-subscribe-modal-container').remove();
          $('#total_price').html(new_total_price);
          $('#basket_item_counter').html(new_basket_amount);


          

      

          list_on_page.append(new_items);
          //$('#instalment_con').find('#bu_con').append(new_instalment);
          list_on_page.append(new_items_offer);
          subs_cont.append(new_modals);
          freeshippingCalculator();
          //totalSave();
          $('#checkout-text').show();
          $('.loader').hide();
          console.log(new_items);
          
      });


      
      if($('#dynamic_quantity_counter')[0]){
        let getID = $('.single_dynamic').data('offerproduct');
        let getMax = $('.single_dynamic').data('max');
        await getTotalItemQuantityOffer(getID,getMax);
        //console.log($('.single_dynamic').data('offerproduct'));
    } 
      


    return result2.json();
   
}
}

function addItemById(variantId, quantity, selling_plan) {
return addItem({
    id: variantId,
    quantity: quantity,
    selling_plan: selling_plan
});

 
}

function addItemByIdSingle(variantId, quantity) {
  return addItem({
      id: variantId,
      quantity: quantity
  });
  
   
  }
//Add to cart new approach



//Update Item
async function updateItem(data) {

  const result3 = await fetch(`${window.Shopify.routes.root}cart/change.json`, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify(data)
  });
  if (result3.status === 200) {
  //console.log('%c'+chekking+' Item updated '+update+' successfully', 'font-size: 20px;');

  let list_on_page = $('#drawer_items');
  
  $.ajax({

      url: `${window.Shopify.routes.root}`,
      type : 'GET',
      dataType : 'html'
      
  }).done(function(drawer_items){
      
       let new_items = $(drawer_items).find('#drawer_items').find('.__item');
      let new_items_offer = $(drawer_items).find('#drawer_items').find('.offer_master');
      let new_total_price = $(drawer_items).find('#total_price').html();
      let new_basket_amount = $(drawer_items).find('#basket_item_counter').html();
       let new_instalment = $(drawer_items).find('#instalment_con').find('#bu_con').html();
      //let new_progress_bar = $(drawer_items).find('#freeShipping').html();    


      $('#drawer_items').find('.__item').remove();
      $('#drawer_items').find('.offer_master').remove();
      $('#total_price').html(new_total_price);
      $('#basket_item_counter').html(new_basket_amount);
      //$('#instalment_con').find('.instalment_drawer_text').remove(); 
      $('#instalment_con').find('#bu_con').remove();
      //$('#freeShipping').html(new_progress_bar);
      list_on_page.append(new_items);
      list_on_page.append(new_items_offer);
      //$('#instalment_con').find('#bu_con').append(new_instalment);
      freeshippingCalculator();
      $('#checkout-text').show();
      $('.loader').hide();
      
  });

  if($('#dynamic_quantity_counter')[0]){
    let getID = $('.single_dynamic').data('offerproduct');
    let getMax = $('.single_dynamic').data('max');
    await getTotalItemQuantityOffer(getID,getMax);
    //console.log($('.single_dynamic').data('offerproduct'));
} 

  return result3.json();
  }
}

function updateItemById(lineItemId, newQuantity) {
  return updateItem({
      id: lineItemId,
      quantity: newQuantity
  });

}

function updateItemByLine(oneBasedLineIndex, newQuantity) {
  return updateItem({
      line: oneBasedLineIndex,
      quantity: newQuantity
  });
}

function updateItemByLineSubs(variantLine, quantity, selling_plan) {
  return updateItem({
      line: variantLine,
      quantity: quantity,
      selling_plan: selling_plan
  });
  
   
  }




//removeItem

async function removeItem(data) {
  const result4 = await fetch(`${window.Shopify.routes.root}cart/change.json`, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify({
          ...data,
          quantity: 0
      })
  });
  if (result4.status === 200) {
    console.log('%c'+chekking+' Item removed '+remove+' successfully', 'font-size: 20px;');



    let list_on_page = $('#drawer_items');
    
    $.ajax({

        url: `${window.Shopify.routes.root}`,
        type : 'GET',
        dataType : 'html'
        
    }).done(function(drawer_items){
        
        let new_items = $(drawer_items).find('#drawer_items').find('.__item');
        let new_items_offer = $(drawer_items).find('#drawer_items').find('.offer_master');
        let new_total_price = $(drawer_items).find('#total_price').html();
        let new_basket_amount = $(drawer_items).find('#basket_item_counter').html();
        //let new_instalment = $(drawer_items).find('#instalment_con').find('#bu_con').html();
        //let new_progress_bar = $(drawer_items).find('#freeShipping').html();    


        $('#drawer_items').find('.__item').remove();
        $('#drawer_items').find('.offer_master').remove();
        //$('#instalment_con').find('.instalment_drawer_text').remove(); 
        $('#instalment_con').find('#bu_con').remove();
        $('#total_price').html(new_total_price);
        $('#basket_item_counter').html(new_basket_amount);
        //$('#freeShipping').html(new_progress_bar);
        //$('#instalment_con').find('#bu_con').append(new_instalment);
        list_on_page.append(new_items);
        list_on_page.append(new_items_offer);
        freeshippingCalculator();
        $('#checkout-text').show();
        $('.loader').hide();
        console.log(new_items);
        
    });


    if($('#dynamic_quantity_counter')[0]){
      let getID = $('.single_dynamic').data('offerproduct');
      let getMax = $('.single_dynamic').data('max');
      await getTotalItemQuantityOffer(getID,getMax);
      //console.log($('.single_dynamic').data('offerproduct'));
  } 

    return result4.json();
    // handle data
}

 
}

function removeItemById(id) {
  return removeItem({ id: id });
}

function removeItemByLine(oneBasedLineIndex) {
  return removeItem({ line: oneBasedLineIndex });
}


function opendrawer(){
  let drawer_position = $(".bambino-drawer").attr("data-position");

  if(drawer_position == "close"){
    $(".drawer_modal_background").css("display","block");

    anime({
      targets: '.bambino-drawer',
      duration: 500,
      translateX:[463,0],
      easing: 'easeOutQuart'
    })
  
    anime({
       targets:'.drawer_modal_background',
       duration: 500,
       opacity:[0,1],
       easing: 'easeOutQuart',
    })
    $(".bambino-drawer").attr("data-position","open");
  }


}

function modalClose(){
  anime({
    targets: '.product_modal_mobile',
    duration: 500,
    easing: 'easeOutQuart',
    opacity: [1, 0],
    complete: () => {
     $('.product_modal_mobile').css('display','none');
 }
})

anime({
targets: '.modal_bg',
duration: 500,
easing: 'easeOutQuart',
opacity: [1, 0],
complete: () => {
 $('.modal_bg').css('display','none');
}
})
}


$(document).on('click','.add_product_', async function (){
  opendrawer();
  $('#checkout-text').hide();
  $('.loader').show();
  let product_id = $(this).attr("data-id");
  let getQuantity = $(this).attr('data-quantity');
  let getSellingPlanIDButton = $(this).attr('data-selling-plan-id');
  let oneTimecheck = $(this).attr('data-onetime');

  let getProductMasterID = $(this).attr('data-productid');
  let bamControl = false;

  let getData = $('.bambino-drawer').attr('data-subs').split(',');
  let getLength = getData.length;



  for( let i = 0; i < getLength; i++ ){

       if(getData[i] == getProductMasterID){
           bamControl = true;
           break;
       }
  }

     if($('.bambino-bam-modal-container').attr('data-position') != 'close')
  {
      anime({
      targets: '.bambino-bam-modal-container',
      duration: 500,
      easing: 'easeOutQuart',
      opacity: [1,0],
      complete: () => {
      $('.bambino-bam-modal-container').attr('data-position','close');
      $('.bambino-bam-modal-container').css('display','none');
      }
     })
  }


  if(bamControl == true){
    $('.bambino-bam-modal-container').css('display','flex');
    anime({
      targets: '.bambino-bam-modal-container',
      duration: 500,
      easing: 'easeOutQuart',
      opacity: [0,1],
      complete: () => {
      $('.bambino-bam-modal-container').attr('data-position','open');
      }
     })
  } 

  if($(this).hasClass('drawer_update_')){
    let dataLine = $(this).parent().parent().parent().parent().parent().parent().attr('data-line');
    //console.log("K:"+dataLine);
    let dataQuantity = $(this).attr('data-quantity');
    let dataSellingPlanID = $(this).attr('data-selling-plan-id');

    $('.bambino-drawer').css('overflow-y','auto');
    
    const result = await updateItemByLineSubs(dataLine, dataQuantity ,dataSellingPlanID);
}else{

  
  if(getQuantity == null || getQuantity == 0 || getQuantity == 'undefind' || getQuantity == "")
    {
      getQuantity = 1;
    }
  if(oneTimecheck == "true"){
    //console.log('valla');

    const lineItemSingle = await addItemByIdSingle(product_id, getQuantity);  
    //console.log(lineItemSingle);
   }else{
    const lineItem = await addItemById(product_id, getQuantity, getSellingPlanIDButton);
    //console.log(lineItem);

   }
  }

});




$(document).on('click','.remove_product', async function (){
  $('#checkout-text').hide();
  $('.loader').show();
  let product_id = $(this).parent().attr("data-id");
  let lineitem_id = $(this).parent().attr("data-line");
  anime({
    targets: '#product_id_'+product_id+'_'+lineitem_id+'',
    duration:300,
    easing: 'easeInOutSine',
    translateX: 370,
    opacity:[1,0],
    complete: async () => {
      const resultRemove = await removeItemByLine(lineitem_id);
    }
  });
  
})







$(document).on('click','.button_plus, .button_minus', async function (e){
  $('#checkout-text').hide();
  $('.loader').show();
  const isNegative = $(e.target).closest('.button_minus').is('.button_minus');
  const input = $(e.target).closest('.__item_quantity_container').find('input');
  if (input.is('input')) {
    input[0][isNegative ? 'stepDown' : 'stepUp']()
  }

  var productQuantity = parseInt($(this).parent().find(".__item_number").find('.holdQuantity').val());

  var product_id = $(this).parent().attr("data-idItem");

  let getLineItem = $(this).parent().parent().parent().parent().attr('data-line');

 // console.log(getLineItem);

  //const result3 = await updateItemById(product_id, productQuantity);

  const result = await updateItemByLine(getLineItem, productQuantity);

});






async function freeshippingCalculator(){
  originalValueDiv = document.querySelectorAll("#originalValueID");
  currentValueDiv = document.querySelectorAll("#currentValueID");

  
  for (var i = 0; i < originalValueDiv.length; i++) {
    var originalValueArr = originalValueDiv[i];
    var currentValueArr = currentValueDiv[i];
    var originalValue = originalValueArr.innerText;
    var currentValue = currentValueArr.innerText;


    if (originalValue.length > 2) {
      OriginalValueParse = parseFloat(originalValue.replace(/[^\d]/g, ''));
      totalDiscountValue += OriginalValueParse;

    }
    else {
      CurrentValueParse = parseFloat(currentValue.replace(/[^\d]/g, ''));
      totalDiscountValue += CurrentValueParse;              
    }
  }


    divSelector = document.getElementById("total_discount");
    divSelector.setAttribute("data-valuehandler", totalDiscountValue);

  let freeShippingRater = $('#freeShipping').attr('data-freeshippingrate');
  let freeGift1Rater = $('#freeShipping').attr('data-freegift1rate');
  let giftToggler = $('#toggleGift').attr('data-toggleGift');
  let priceInArray_;

  const cart8 = await getCart();
  let totalAm = cart8.total_price;

  if(totalAm > 3499){
     $('.drawer_fixed__').addClass('drawer_fixed_has_padding');
     $('.drawer_top').addClass('drawer_fixed_has_item');
     
      
     //let format = totalAm;
     //let FormatMa = format / 100
    
  }else{
     $('.drawer_fixed__').removeClass('drawer_fixed_has_padding');
     $('.drawer_top').removeClass('drawer_fixed_has_item');
    
  }

  

    if(totalAm > 3499 && totalAm <= 9999){
      priceInArray_ = 3; 
    }

    if(totalAm >= 10000 && totalAm <= 12499){
    priceInArray_ = 6;   
    }

    if(totalAm >= 12500 && totalAm <= 21999){
    priceInArray_ = 9;   
    }

    if(totalAm >= 22000 ){
    priceInArray_ = 12;
    }

  
    if(totalAm > 3499){
     $('.instalment_drawer_text').show();  
    let pValue = ((totalAm / 100)/priceInArray_).toFixed(2);
    let pFormat = pValue*100;
    let HTMLGet = `
            <span id="bu_con">
             <button data-price="${totalAm}" data-translate="monthly payments" data-klarnatext="monthly payments" class="drawer_instalment_button" id="drawer_instalment_button">Instalment Options</button>
            </span> 
            <div class="instalment_drawer_text">
                <p>
                  Monthly instalments available.
                  <span>Interest free</span>, from <span id="instalment_value">£${pFormat/100} p/m</span> 
                </p>
             </div>
             `;
    $('#instalment_con').find('.instalment_drawer_text').remove();
    $('#instalment_con').append(HTMLGet);}else{
        $('.instalment_drawer_text').hide();
    }


  var discValue = parseFloat($('#total_discount').attr('data-valuehandler'));


  var totalDiscValue = parseInt((totalDiscountValue - totalAm));

  var totalDiscValueDivide = totalDiscValue/100;

  divSelector.innerText = Shopify.formatMoney(totalDiscValue, theme.moneyFormat);

  divSelector.setAttribute("data-valuehandler", "0");
  totalDiscountValue = 0;
  totalDiscValue = 0;

  free_shipping_amount = freeShippingRater - totalAm;
  free_gift1_amount = freeGift1Rater - totalAm;

  

  let percentCalc = (totalAm * 100) / freeShippingRater;
  let percentAnim = percentCalc;



  if (giftToggler = true) {
    let percentCalcGift1 = (totalAm * 100) / freeGift1Rater;
    let percentAnimGift1 = percentCalcGift1;

    

  anime({
       targets: '.progress___',
       width: ''+percentAnim+'%',
       duration:300,
       easing: 'easeInOutSine'
  })


      var progressC = [];
      var progressI = [];
      
      for (var i = 1; i < 4; i++) {
        progressC[i] =  document.getElementById("progressCircle" + [i]);
        progressI[i] =  document.getElementById("progressIcon" + [i]);
      }
    
    if(percentAnim >= 100){
      percentAnim = 100;


      $('#free_shipping___text').hide();

      $('#free_shipping___success').show();

      progressC[1].style.backgroundColor = "rgba(255,255,255,1)";
      progressI[1].style.color = "#a587c8";
    }
    else{


      progressC[1].style.backgroundColor = "rgba(255,255,255,1)";
      progressI[1].style.color = "#a587c8";

      
      $('#free_shipping___success').hide();
      
      $('#free_shipping___text').show();
      $('#free_shipping_amount').html(Shopify.formatMoney(free_shipping_amount, theme.moneyFormat));

    }
  if (percentAnimGift1 >= 100){
      percentAnimGift1 = 100;
      percentAnim = 100;


      progressC[1].style.backgroundColor = "rgba(165,135,200,1)";
      progressI[1].style.color = "#fff";
        
        $('#free_shipping___text').hide();

        $('#free_shipping___success').show();
  }


}
  


  else{
    if(percentAnim >= 100){
      percentAnim = 100;
      $('#free_shipping___success').show();
    }
    else{
      $('#free_shipping___text').show();
      $('#free_shipping_amount').html(Shopify.formatMoney(free_shipping_amount, theme.moneyFormat));
    }

  anime({
       targets: '.progress___',
       width: ''+percentAnim+'%',
       duration:300,
       easing: 'easeInOutSine'
  })
 
  }
  



  



}

freeshippingCalculator();


/*-----------------------------------------------------*/
/*----------------Bind Product Drawer End--------------*/
/*-----------------------------------------------------*/ 


async function getTotalItemQuantityOffer(productID,maxValue){
  let getPID = productID;
  const cart8 = await getCart();
  let quantityValue;
  let maxValueCalc = maxValue;
  let TotalValue = 0;

  for (const product of cart8.items) {
      //console.log(product.product_id+'/'+getPID);
    if( product.product_id == getPID ){
        quantityValue = product.quantity;
        TotalValue = TotalValue + quantityValue;
    }
      
  }
  let finalValue = maxValueCalc - TotalValue;
   if( TotalValue >= maxValueCalc){
      $('#process_').hide();
      $('#done_').show(); 
   }else{
      $('#dynamic_quantity_counter').html(finalValue);
      $('#process_').show();
      $('#done_').hide(); 
   }
 
}